// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhoneVerificationModal-errorMessage-UhqB8 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.PhoneVerificationModal-space1-jCBiF {
	margin-bottom: 6px !important;
}
.PhoneVerificationModal-space2-tmYGy {
	margin-bottom: 12px !important;
}
.PhoneVerificationModal-space3-zjZSK {
	margin-bottom: 18px !important;
}
.PhoneVerificationModal-space4-UP3ub {
	margin-bottom: 24px !important;
}
.PhoneVerificationModal-space5-GkABx {
	margin-bottom: 30px !important;
}
.PhoneVerificationModal-space6-MO7a6 {
	margin-bottom: 36px !important;
}
.PhoneVerificationModal-space7-UIK2_ {
	margin-bottom: 42px !important;
}
.PhoneVerificationModal-spaceTop8-ohqx9 {
	margin-bottom: 48px !important;
}
.PhoneVerificationModal-spaceTop1-OBuOx {
	margin-top: 6px !important;
}
.PhoneVerificationModal-spaceTop2-kdSsd {
	margin-top: 12px !important;
}
.PhoneVerificationModal-spaceTop3-_DvDF {
	margin-top: 18px !important;
}
.PhoneVerificationModal-spaceTop4-AGEjU {
	margin-top: 24px !important;
}
.PhoneVerificationModal-spaceTop5-F8OQm {
	margin-top: 30px !important;
}
.PhoneVerificationModal-spaceTop6-urYzu {
	margin-top: 36px !important;
}
.PhoneVerificationModal-spaceTop7-ZVpMw {
	margin-top: 42px !important;
}
.PhoneVerificationModal-spaceTop8-ohqx9 {
	margin-top: 48px !important;
}
.PhoneVerificationModal-noMargin-prE0u {
	margin: 0px !important;
}
.PhoneVerificationModal-padding1-ulc2Y {
	padding-bottom: 6px !important;
}
.PhoneVerificationModal-padding2-CzKlK {
	padding-bottom: 12px !important;
}
.PhoneVerificationModal-padding3-zxjmf {
	padding-bottom: 18px !important;
}
.PhoneVerificationModal-padding4-E5EWU {
	padding-bottom: 24px !important;
}
.PhoneVerificationModal-padding5-N6FLc {
	padding-bottom: 30px !important;
}
.PhoneVerificationModal-padding6-g6CP4 {
	padding-bottom: 36px !important;
}
.PhoneVerificationModal-padding7-SfzRr {
	padding-bottom: 42px !important;
}
.PhoneVerificationModal-paddingTop1-I82t6 {
	padding-top: 6px !important;
}
.PhoneVerificationModal-paddingTop2-smJp4 {
	padding-top: 12px !important;
}
.PhoneVerificationModal-paddingTop3-IXGa5 {
	padding-top: 18px !important;
}
.PhoneVerificationModal-paddingTop4-nkjLC {
	padding-top: 24px !important;
}
.PhoneVerificationModal-paddingTop5-lo4Y5 {
	padding-top: 30px !important;
}
.PhoneVerificationModal-paddingTop6-EBpTW {
	padding-top: 36px !important;
}
.PhoneVerificationModal-paddingTop7-vmZ28 {
	padding-top: 42px !important;
}
.PhoneVerificationModal-noPadding-PND3z {
	padding: 0px !important;
}
.PhoneVerificationModal-textBold-MLDtV {
	font-weight: 500 !important;
}
.PhoneVerificationModal-textBolder-zB2Mt {
	font-weight: 700 !important;
}
.PhoneVerificationModal-textNormal-B7LlZ {
	font-weight: normal !important;
}
.PhoneVerificationModal-spaceBottom20-C5bUU {
	margin-bottom: 20px;
}
.PhoneVerificationModal-spaceBottom10-azhUF {
	margin-bottom: 10px;
}
.PhoneVerificationModal-marginNone-H_Xyf {
	margin: 0;
}
.PhoneVerificationModal-spaceBottom15-ZrTMN {
	margin-bottom: 15px;
}
.PhoneVerificationModal-marginTopNone-ogfIR {
	margin-top: 0;
}
.PhoneVerificationModal-spaceTop11-uhSGS {
	margin-top: 11px;
}
.PhoneVerificationModal-spaceTop21-Y6C7b {
	margin-top: 21px;
}
.PhoneVerificationModal-spaceTop20-x3Ilz {
	margin-top: 20px;
}
.PhoneVerificationModal-spaceTop10-n5DSx {
	margin-top: 10px;
}
/*New Design Text Colors */
.PhoneVerificationModal-textDarkBlue-Z9Em9 {
	color: rgb(20, 39, 94) !important;
}
.PhoneVerificationModal-textLightBlue-nOKKA {
	color: rgb(57, 87, 106) !important;
}
.PhoneVerificationModal-textLightSandleGreen-qILE0 {
	color: rgb(76, 86, 41) !important;
}
.PhoneVerificationModal-textLightBrown-GVjJp {
	color: rgb(115, 79, 33) !important;
}
.PhoneVerificationModal-textMediumMaroon-ag2zk {
	color: rgb(87, 37, 51) !important;
}
.PhoneVerificationModal-textBrown-kG6yQ {
	color: rgb(160, 47, 24) !important;
}
.PhoneVerificationModal-textMaroon-ZjUpP {
	color: rgb(155, 49, 67) !important;
}
.PhoneVerificationModal-textDarkBrown-mVCJ3 {
	color: rgb(83, 18, 16) !important;
}
.PhoneVerificationModal-textMediumBrown-DYSOW {
	color: rgb(142, 28, 10) !important;
}
.PhoneVerificationModal-textSkyBlue-Ec421 {
	color: rgb(37, 117, 141) !important;
}
.PhoneVerificationModal-textGray-jWI0m {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.PhoneVerificationModal-formContainer-uL8ik {
    /* max-width: 380px; */
    width: 100%;
}
.PhoneVerificationModal-noMargin-prE0u {
    margin: 0px;
}
.PhoneVerificationModal-modalCaptionLink-cmOxV {
    color: var(--primary-link-foreground);
    font-size: 14px;
}
.PhoneVerificationModal-modalCaptionLinkLarge-A3frB {
    font-size: 16px;
    line-height: 32px;
}
.PhoneVerificationModal-modalCaptionLink-cmOxV:hover,
.PhoneVerificationModal-modalCaptionLink-cmOxV:focus {
    color: var(--primary-link-foreground);
    text-decoration: underline;
    cursor: pointer;
}
.PhoneVerificationModal-labelText-bkU9Q {
    font-size: 16px;
    color: var(--secondary-foreground);
    margin: 6px 0px;
    line-height: 1.43;
    font-weight: normal
}
.PhoneVerificationModal-iconSize-ckTTh,
.PhoneVerificationModal-iconSize-ckTTh:hover,
.PhoneVerificationModal-iconSize-ckTTh:active {
    font-size: 20px;
    color: var(--secondary-bg);
    text-decoration: none;
    cursor: pointer;
}
.PhoneVerificationModal-tableBox-qpSXt {
    width: 100%;
    border: 1px solid var(--primary-border);
    height: 58px;
}
.PhoneVerificationModal-tableBoxHeader-APOWz {
    color: var(--primary-foreground);
    border-right: 1px solid var(--primary-border);
    padding: 0px 10px;
    width: 30%;
}
.PhoneVerificationModal-tableBox-qpSXt tr td {
    padding: 18px 10px;
    color: var(--primary-foreground);
    font-size: 14px;
}
.PhoneVerificationModal-confirmedIcon-EdXrB {
    font-size: 20px;
    color: var(--secondary-bg);
    vertical-align: sub;
}
.PhoneVerificationModal-btnFlex-lR5k4 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 3px;
}
.PhoneVerificationModal-confirmedText-P5fQU {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 3px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin: 0;
}
@media screen and (max-width: 767px) {
    .PhoneVerificationModal-tableBox-qpSXt tr {
        display: block;
        width: 100%;
        position: relative;
    }

    .PhoneVerificationModal-tableBoxHeader-APOWz {
        display: block;
        padding: 10px;
        border-right-width: 0px;
        border-bottom: 1px solid var(--primary-border);
        width: 100%;
    }

    .PhoneVerificationModal-tableBox-qpSXt tr td {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/PhoneVerificationModal/PhoneVerificationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,sBAAsB;AACtB;IACI,sBAAsB;IACtB,WAAW;AACf;AAEA;IACI,WAAW;AACf;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AAEA;;IAEI,qCAAqC;IACrC,0BAA0B;IAC1B,eAAe;AACnB;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,iBAAiB;IACjB;AACJ;AAEA;;;IAGI,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;AACnB;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,YAAY;AAChB;AAEA;IACI,gCAAgC;IAChC,6CAA6C;IAC7C,iBAAiB;IACjB,UAAU;AACd;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAe;QAAf,eAAe;IACf,QAAQ;AACZ;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,QAAQ;IACR,mBAAe;QAAf,eAAe;IACf,SAAS;AACb;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,uBAAuB;QACvB,8CAA8C;QAC9C,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n/** RentAll - Begin **/\n.formContainer {\n    /* max-width: 380px; */\n    width: 100%;\n}\n\n.noMargin {\n    margin: 0px;\n}\n\n.modalCaptionLink {\n    color: var(--primary-link-foreground);\n    font-size: 14px;\n}\n\n.modalCaptionLinkLarge {\n    font-size: 16px;\n    line-height: 32px;\n}\n\n.modalCaptionLink:hover,\n.modalCaptionLink:focus {\n    color: var(--primary-link-foreground);\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.labelText {\n    font-size: 16px;\n    color: var(--secondary-foreground);\n    margin: 6px 0px;\n    line-height: 1.43;\n    font-weight: normal\n}\n\n.iconSize,\n.iconSize:hover,\n.iconSize:active {\n    font-size: 20px;\n    color: var(--secondary-bg);\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.tableBox {\n    width: 100%;\n    border: 1px solid var(--primary-border);\n    height: 58px;\n}\n\n.tableBoxHeader {\n    color: var(--primary-foreground);\n    border-right: 1px solid var(--primary-border);\n    padding: 0px 10px;\n    width: 30%;\n}\n\n.tableBox tr td {\n    padding: 18px 10px;\n    color: var(--primary-foreground);\n    font-size: 14px;\n}\n\n.confirmedIcon {\n    font-size: 20px;\n    color: var(--secondary-bg);\n    vertical-align: sub;\n}\n\n.btnFlex {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 3px;\n}\n\n.confirmedText {\n    display: flex;\n    gap: 3px;\n    flex-wrap: wrap;\n    margin: 0;\n}\n\n@media screen and (max-width: 767px) {\n    .tableBox tr {\n        display: block;\n        width: 100%;\n        position: relative;\n    }\n\n    .tableBoxHeader {\n        display: block;\n        padding: 10px;\n        border-right-width: 0px;\n        border-bottom: 1px solid var(--primary-border);\n        width: 100%;\n    }\n\n    .tableBox tr td {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `PhoneVerificationModal-errorMessage-UhqB8`,
	"space1": `PhoneVerificationModal-space1-jCBiF`,
	"space2": `PhoneVerificationModal-space2-tmYGy`,
	"space3": `PhoneVerificationModal-space3-zjZSK`,
	"space4": `PhoneVerificationModal-space4-UP3ub`,
	"space5": `PhoneVerificationModal-space5-GkABx`,
	"space6": `PhoneVerificationModal-space6-MO7a6`,
	"space7": `PhoneVerificationModal-space7-UIK2_`,
	"spaceTop8": `PhoneVerificationModal-spaceTop8-ohqx9`,
	"spaceTop1": `PhoneVerificationModal-spaceTop1-OBuOx`,
	"spaceTop2": `PhoneVerificationModal-spaceTop2-kdSsd`,
	"spaceTop3": `PhoneVerificationModal-spaceTop3-_DvDF`,
	"spaceTop4": `PhoneVerificationModal-spaceTop4-AGEjU`,
	"spaceTop5": `PhoneVerificationModal-spaceTop5-F8OQm`,
	"spaceTop6": `PhoneVerificationModal-spaceTop6-urYzu`,
	"spaceTop7": `PhoneVerificationModal-spaceTop7-ZVpMw`,
	"noMargin": `PhoneVerificationModal-noMargin-prE0u`,
	"padding1": `PhoneVerificationModal-padding1-ulc2Y`,
	"padding2": `PhoneVerificationModal-padding2-CzKlK`,
	"padding3": `PhoneVerificationModal-padding3-zxjmf`,
	"padding4": `PhoneVerificationModal-padding4-E5EWU`,
	"padding5": `PhoneVerificationModal-padding5-N6FLc`,
	"padding6": `PhoneVerificationModal-padding6-g6CP4`,
	"padding7": `PhoneVerificationModal-padding7-SfzRr`,
	"paddingTop1": `PhoneVerificationModal-paddingTop1-I82t6`,
	"paddingTop2": `PhoneVerificationModal-paddingTop2-smJp4`,
	"paddingTop3": `PhoneVerificationModal-paddingTop3-IXGa5`,
	"paddingTop4": `PhoneVerificationModal-paddingTop4-nkjLC`,
	"paddingTop5": `PhoneVerificationModal-paddingTop5-lo4Y5`,
	"paddingTop6": `PhoneVerificationModal-paddingTop6-EBpTW`,
	"paddingTop7": `PhoneVerificationModal-paddingTop7-vmZ28`,
	"noPadding": `PhoneVerificationModal-noPadding-PND3z`,
	"textBold": `PhoneVerificationModal-textBold-MLDtV`,
	"textBolder": `PhoneVerificationModal-textBolder-zB2Mt`,
	"textNormal": `PhoneVerificationModal-textNormal-B7LlZ`,
	"spaceBottom20": `PhoneVerificationModal-spaceBottom20-C5bUU`,
	"spaceBottom10": `PhoneVerificationModal-spaceBottom10-azhUF`,
	"marginNone": `PhoneVerificationModal-marginNone-H_Xyf`,
	"spaceBottom15": `PhoneVerificationModal-spaceBottom15-ZrTMN`,
	"marginTopNone": `PhoneVerificationModal-marginTopNone-ogfIR`,
	"spaceTop11": `PhoneVerificationModal-spaceTop11-uhSGS`,
	"spaceTop21": `PhoneVerificationModal-spaceTop21-Y6C7b`,
	"spaceTop20": `PhoneVerificationModal-spaceTop20-x3Ilz`,
	"spaceTop10": `PhoneVerificationModal-spaceTop10-n5DSx`,
	"textDarkBlue": `PhoneVerificationModal-textDarkBlue-Z9Em9`,
	"textLightBlue": `PhoneVerificationModal-textLightBlue-nOKKA`,
	"textLightSandleGreen": `PhoneVerificationModal-textLightSandleGreen-qILE0`,
	"textLightBrown": `PhoneVerificationModal-textLightBrown-GVjJp`,
	"textMediumMaroon": `PhoneVerificationModal-textMediumMaroon-ag2zk`,
	"textBrown": `PhoneVerificationModal-textBrown-kG6yQ`,
	"textMaroon": `PhoneVerificationModal-textMaroon-ZjUpP`,
	"textDarkBrown": `PhoneVerificationModal-textDarkBrown-mVCJ3`,
	"textMediumBrown": `PhoneVerificationModal-textMediumBrown-DYSOW`,
	"textSkyBlue": `PhoneVerificationModal-textSkyBlue-Ec421`,
	"textGray": `PhoneVerificationModal-textGray-jWI0m`,
	"formContainer": `PhoneVerificationModal-formContainer-uL8ik`,
	"modalCaptionLink": `PhoneVerificationModal-modalCaptionLink-cmOxV`,
	"modalCaptionLinkLarge": `PhoneVerificationModal-modalCaptionLinkLarge-A3frB`,
	"labelText": `PhoneVerificationModal-labelText-bkU9Q`,
	"iconSize": `PhoneVerificationModal-iconSize-ckTTh`,
	"tableBox": `PhoneVerificationModal-tableBox-qpSXt`,
	"tableBoxHeader": `PhoneVerificationModal-tableBoxHeader-APOWz`,
	"confirmedIcon": `PhoneVerificationModal-confirmedIcon-EdXrB`,
	"btnFlex": `PhoneVerificationModal-btnFlex-lR5k4`,
	"confirmedText": `PhoneVerificationModal-confirmedText-P5fQU`
};
module.exports = ___CSS_LOADER_EXPORT___;
